import React from 'react'
import { Dropdown as SemanticuiDropdown } from 'semantic-ui-react'
import styled from 'styled-components'
import dayjs from 'dayjs'
import { getWorkspaceTimezone, getWorkspaceTimezoneLabel } from 'libs/date'

/** @type {typeof SemanticuiDropdown} */
const Dropdown = styled(SemanticuiDropdown)`
  && {
    border-left: 1px solid rgba(255, 255, 255, 0.5);
  }

  &&& > .menu .text {
    white-space: nowrap;
  }
`

export const TIME_PICKER_OPTIONS = [
  { text: '12:00 AM', value: 0 },
  { text: '1:00 AM', value: 1 },
  { text: '2:00 AM', value: 2 },
  { text: '3:00 AM', value: 3 },
  { text: '4:00 AM', value: 4 },
  { text: '5:00 AM', value: 5 },
  { text: '6:00 AM', value: 6 },
  { text: '7:00 AM', value: 7 },
  { text: '8:00 AM', value: 8 },
  { text: '9:00 AM', value: 9 },
  { text: '10:00 AM', value: 10 },
  { text: '11:00 AM', value: 11 },
  { text: '12:00 PM', value: 12 },
  { text: '1:00 PM', value: 13 },
  { text: '2:00 PM', value: 14 },
  { text: '3:00 PM', value: 15 },
  { text: '4:00 PM', value: 16 },
  { text: '5:00 PM', value: 17 },
  { text: '6:00 PM', value: 18 },
  { text: '7:00 PM', value: 19 },
  { text: '8:00 PM', value: 20 },
  { text: '9:00 PM', value: 21 },
  { text: '10:00 PM', value: 22 },
  { text: '11:00 PM', value: 23 },
]

/**
 *
 * @param {object} props
 * @param {object} [props.className]
 * @param {number} props.scheduleTime
 * @param {function} props.setScheduleTime
 * @param {boolean=} props.isScheduleDateMatchToday
 * @param {boolean=} props.allowLastHour
 */
export default function TimePicker({
  className,
  setScheduleTime,
  scheduleTime,
  isScheduleDateMatchToday,
  allowLastHour = false,
}) {
  const workspaceTimezone = getWorkspaceTimezone()
  const nextHourInLocalTimeZone = dayjs().tz(workspaceTimezone).hour() + (!allowLastHour ? 1 : 0)

  function addDisableOptions(options) {
    const disableOptions = options.map((option) => {
      if (option['value'] < nextHourInLocalTimeZone) {
        return { ...option, disabled: true }
      }
      return option
    })
    return disableOptions
  }

  return (
    <Dropdown
      className={className}
      value={scheduleTime}
      selection
      compact
      options={
        isScheduleDateMatchToday ? addDisableOptions(TIME_PICKER_OPTIONS) : TIME_PICKER_OPTIONS
      }
      onChange={(_, { value }) => setScheduleTime(value)}
      placeholder="Select Time"
      search
    />
  )
}

/**
 *
 * @param {object} props
 * @param {string=} props.className
 */
export function TimeZone({ className = '' }) {
  const workspaceTimezoneLabel = getWorkspaceTimezoneLabel()
  return <span className={`mt2 h5 text-grey ${className}`}>{workspaceTimezoneLabel}</span>
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/TimePicker/index.js